import { ButtonProps } from "../../Models/ButtonInterface";
import Icon from "../Icon";
import { ButtonStyled, TextContainer } from "./Button.styled";

const Button = ({
  text,
  iconButton,
  iconButtonLeft,
  colorIcon,
  sizeIcon,
  colorButton,
  onClick,
  disabled,
}: ButtonProps) => {
  return (
    <ButtonStyled
      colorButton={colorButton}
      onClick={onClick}
      disabled={disabled}
    >
      <TextContainer iconButton={iconButton} iconButtonLeft={iconButtonLeft}>
        {iconButtonLeft && (
          <Icon
            icon={iconButtonLeft ? iconButtonLeft : ""}
            color={colorIcon}
            size={sizeIcon}
          />
        )}
        <span>{text}</span>
        {iconButton && (
          <Icon
            icon={iconButton ? iconButton : ""}
            color={colorIcon}
            size={sizeIcon}
          />
        )}
      </TextContainer>
    </ButtonStyled>
  );
};

export default Button;
